import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PromocionesService {
  constructor(
    private _http: HttpClient
  ) { }


  ListarPromociones(data?: any) {
    const url = environment.URL_BASE + "ReportePromocionAuthorization/detallado"
    return this._http.post(url,data)
  }

  requestReportePromocionSinPaginacion(data: any) {
    // console.log('reporte de para dockes')
    let url = environment.URL_REPORTE + 'reportes/detalladoPromociones';
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Credentials', 'true');
  
    return this._http.post(url, data, { responseType: 'blob', headers }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
  
      )));
  
  }

  GetRequiereClaveReportePromociones(idEmpresa: any, idRol: any) {
    const url = environment.URL_BASE + `ReportePromocionAuthorization/GetRequiereClaveReportePromociones?IdEmpresa=${idEmpresa}&IdRol=${idRol}`
    return this._http.get(url)
  }

  ValidarClaveAccesoReportePromociones(data: any) {
    const url = environment.URL_BASE + "ReportePromocionAuthorization/ValidarClaveAccesoReportePromociones"
    return this._http.post(url, data)
  }

  ListarAuditoria(idEmpresa: any) {
    const url = environment.URL_BASE + `ReportePromocionAuthorization/ListarAuditoriaReportePromociones?IdEmpresa=${idEmpresa}`
    return this._http.get(url)
  }


}




